import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';
import { listFieldsForCategory } from 'graphql/operations';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';
import Question from 'components/threepp/assessment/Question/Question';
import SkeletonQuestion from 'components/threepp/assessment/Question/SkeletonQuestion/SkeletonQuestion';
import VisibilitySensor from 'components/common/VisibilitySensor/VisibilitySensor';

export class QuestionsManager extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    hasMore: PropTypes.bool,
    hasFields: PropTypes.bool,
    lastCursor: PropTypes.number,
    loading: PropTypes.bool.isRequired,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    questions: PropTypes.array.isRequired,
    assessment: PropTypes.object.isRequired,
    onQueryComplete: PropTypes.func.isRequired,
    queryVariables: PropTypes.object.isRequired,
    /* eslint-enable react/forbid-prop-types */
    incrementAttachmentUploadCount: PropTypes.func.isRequired,
    decrementAttachmentUploadCount: PropTypes.func.isRequired
  };

  static defaultProps = {
    visible: false,
    hasMore: false,
    hasFields: false,
    lastCursor: null
  };

  constructor(props) {
    super(props);
    this.state = this.initState();
  }

  initState = () => {
    return {
      uploadingAttachment: false
    };
  };

  setUploadingAttachment = (uploadingAttachmentInput, questionIdInput) => {
    this.setState({ uploadingAttachment: uploadingAttachmentInput, questionId: questionIdInput });
  };

  componentDidUpdate(prevProps) {
    const { loading, onQueryComplete } = this.props;
    if (loading !== prevProps.loading) {
      if (!loading) {
        const { lastCursor, hasMore, hasFields, queryVariables } = this.props;
        onQueryComplete(lastCursor, hasMore, hasFields, queryVariables);
      }
    }
  }

  render() {
    const {
      visible,
      questions,
      assessment,
      incrementAttachmentUploadCount,
      decrementAttachmentUploadCount,
      selectedCategoryLoading,
      actions,
      invokeActionsForFields,
      categoryAclAction,
      fvlAction,
      setAssigneesForField,
      currentUser
    } = this.props;
    if (!visible) {
      return null;
    }
    const { uploadingAttachment, questionId } = this.state;
    const questionSubset = questions.map(question => {
      /* eslint-disable react/jsx-wrap-multilines */
      return (
        <VisibilitySensor
          key={question.id}
          selectedCategoryLoading={selectedCategoryLoading}
          visibleElement={
            <Question
              question={question}
              actions={actions}
              invokeActionsForFields={invokeActionsForFields}
              categoryAclAction={categoryAclAction}
              assessment={assessment}
              fvlAction={fvlAction}
              setAssigneesForField={setAssigneesForField}
              currentUser={currentUser}
              incrementAttachmentUploadCount={incrementAttachmentUploadCount}
              decrementAttachmentUploadCount={decrementAttachmentUploadCount}
              setUploadingAttachment={this.setUploadingAttachment}
              uploadingAttachment={uploadingAttachment}
              questionId={questionId}
            />
          }
          skeletonElement={<SkeletonQuestion />}
        />
      );
    });
    return questionSubset;
  }
}

export const QuestionLoaderHOC = compose(
  withRouter,
  graphql(listFieldsForCategory, {
    options: props => ({
      variables: props.variables,
      fetchPolicy: NETWORK_ONLY
    })
  }),
  mapProps(props => {
    const { assessment, data, visible, onQueryComplete, variables, invokeActionsForFields } = props;
    let questions = [];
    let hasMore = false;
    let hasFields = false;
    let lastCursor = null;

    if (data.listFieldsForCategory) {
      const { edges, pageInfo } = props.data.listFieldsForCategory;
      questions = edges.map(edge => edge.node);
      hasMore = pageInfo.hasNextPage;
      hasFields = questions.length > 0;
      lastCursor = pageInfo.hasNextPage ? edges[edges.length - 1].cursor : null;
    }

    return {
      loading: props.data.loading,
      queryVariables: variables,
      visible,
      questions,
      hasMore,
      hasFields,
      lastCursor,
      onQueryComplete,
      assessment,
      invokeActionsForFields,
      actions: props.actions,
      categoryAclAction: props.categoryAclAction,
      fvlAction: props.fvlAction,
      setAssigneesForField: props.setAssigneesForField,
      currentUser: props.currentUser,
      incrementAttachmentUploadCount: props.incrementAttachmentUploadCount,
      decrementAttachmentUploadCount: props.decrementAttachmentUploadCount,
      selectedCategoryLoading: props.selectedCategoryLoading
    };
  })
);

export default QuestionLoaderHOC(QuestionsManager);
